import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as ChevronDownIcon } from './chevronDown.svg';

export const ChevronDown = IconHOC(ChevronDownIcon);
